export default "__VITE_ASSET__70ea36b9__"